export default function buildNavigateToParams (parking, search) {
    return {
        parkingId: parking.id,
        parkingSlug: parking.slug,
        provinceSlug: parking.province.slug,
        startDate: search.start,
        endDate: search.end,
    }
}
